import { render } from "./PanelShare.vue?vue&type=template&id=12da966d&scoped=true&ts=true"
import script from "./PanelShare.vue?vue&type=script&lang=ts"
export * from "./PanelShare.vue?vue&type=script&lang=ts"

import "./PanelShare.vue?vue&type=style&index=0&id=12da966d&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12da966d"]])

export default __exports__